// generated by svgr from images/linkedin.svg

import React from 'react'

function LinkedinIcon(props) {
  return (
    <svg viewBox='0 0 28 30' {...props}>
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M25.85 0H2.15C1 0 .09.95.09 2.12v25.34c0 1.17.92 2.12 2.06 2.12h23.7c1.14 0 2.06-.95 2.06-2.12V2.12C27.9.95 26.99 0 25.85 0zM8.53 24.76h-4.2V11.41h4.2v13.35zM6.4 9.58h.03c1.46 0 2.37-1.02 2.37-2.3-.03-1.32-.91-2.31-2.35-2.31s-2.38 1-2.38 2.3c0 1.29.92 2.31 2.33 2.31zm17.27 15.18h-4.2v-7.14c0-1.8-.6-3.03-2.13-3.03-1.16 0-1.85.83-2.15 1.63-.11.28-.14.68-.14 1.08v7.46h-4.2s.05-12.1 0-13.35h4.2v1.89a4.14 4.14 0 013.79-2.2c2.76 0 4.83 1.9 4.83 6v7.66zm-8.6-11.46a.96.96 0 00-.05.06h.04v-.06z'
      />
    </svg>
  )
}

export default LinkedinIcon
